<h3 mat-dialog-title>{{options.title | translate}}</h3>
<div mat-dialog-content>
  <p>{{options.message | translate}}</p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button color="primary" [mat-dialog-close]="false">{{ 'buttons.no' | translate }}</button>
  <span class="spacer"></span>
  <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ 'buttons.yes' | translate }}</button>
</div>